import { CampaignTypeWithMappedPurposeAndDisplayStatus } from '@mm/state/selectors/campaignSelectors';
import { useMemo } from 'react';
import { getHTMLText } from '../SlideoutEmail/editor/utils';

export const useSOLDNotifications = (
  campaign?: CampaignTypeWithMappedPurposeAndDisplayStatus,
) => {
  const hasSMSNotificationContent = useMemo(
    () =>
      getHTMLText(
        campaign?.soldConfigurations?.unicorn?.notifications?.sms?.content ||
          '',
      ).length,
    [campaign?.soldConfigurations?.unicorn.notifications.sms.content],
  );

  const hasSMSNotificationPhones = useMemo(() => {
    return campaign?.soldConfigurations?.unicorn?.notifications?.sms?.to
      ?.length;
  }, [campaign?.soldConfigurations?.unicorn?.notifications?.sms?.to?.length]);

  const canActivateSmsNotification =
    hasSMSNotificationContent && hasSMSNotificationPhones;

  const canActivateSlackNotification = useMemo(() => {
    const { teamId, slackChannelId, content } =
      campaign?.soldConfigurations?.unicorn?.notifications?.slack || {};

    return teamId && slackChannelId && getHTMLText(content || '').length;
  }, [campaign?.soldConfigurations?.unicorn?.notifications?.slack]);

  const hasEmailNotificationContent = useMemo(
    () =>
      getHTMLText(
        campaign?.soldConfigurations?.unicorn?.notifications?.email?.content ||
          '',
      ).length,
    [campaign?.soldConfigurations?.unicorn?.notifications?.email?.content],
  );

  const hasEmailNotificationEmails = useMemo(() => {
    return campaign?.soldConfigurations?.unicorn?.notifications?.email?.to
      ?.length;
  }, [campaign?.soldConfigurations?.unicorn?.notifications?.email?.to?.length]);

  const canActivateEmailNotification =
    hasEmailNotificationContent && hasEmailNotificationEmails;

  return {
    hasSMSNotificationContent,
    hasSMSNotificationPhones,
    canActivateSmsNotification,
    canActivateSlackNotification,
    hasEmailNotificationContent,
    hasEmailNotificationEmails,
    canActivateEmailNotification,
  };
};
